import React, { createContext, useContext, useRef, useCallback, useState } from 'react';
import { SheetRef } from 'react-modal-sheet';

type BottomSheetContextType = {
  snapTo: (index: number) => void;
  bottomSheetRef: React.MutableRefObject<SheetRef | undefined>;
  keyboardVisible: boolean;
  setKeyboardVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

const BottomSheetContext = createContext<BottomSheetContextType | undefined>(undefined);

export const BottomSheetProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const bottomSheetRef = useRef<SheetRef>();
  const snapTo = useCallback((index: number) => {
    bottomSheetRef.current?.snapTo(index);
  }, []);
  const [keyboardVisible, setKeyboardVisible] = useState(false);

  return (
    <BottomSheetContext.Provider
      value={{ snapTo, bottomSheetRef, keyboardVisible, setKeyboardVisible }}
    >
      {children}
    </BottomSheetContext.Provider>
  );
};

export const useBottomSheet = () => {
  const context = useContext(BottomSheetContext);
  if (!context) {
    throw new Error('useBottomSheet must be used within a BottomSheetProvider');
  }
  return context;
};
